import { Overrides } from '@material-ui/core/styles/overrides'
import { Palette } from '@material-ui/core/styles/createPalette'

const overrides = (palette: Palette): Overrides => ({
  MuiButton: {
    root: {
      textTransform: 'none'
    }
  },
  MuiAppBar: {
    root: {
      backgroundColor: palette.background.paper,
      boxShadow: '0 4px 16px 0 #00000014'
    }
  },
  MuiToolbar: {
    root: {
      backgroundColor: palette.background.paper
    }
  }
})

export default overrides
